import React from 'react';

const TabContext = React.createContext({
  fullWidth: false,
  selected: false
});

export default TabContext;
